/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
// import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const SatelliteSignalIconOutline = createIcon({
  displayName: 'SatelliteSignalIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M13.6832 6.90616l-2.4752e-07 2.4752e-07c.941827-.941828 2.46883-.941829 3.41066-1.64666e-06 3.83532e-07 3.83532e-07 7.68093e-07 7.68093e-07 1.15163e-06 1.15162e-06v0l1.31959e-07 1.31959e-07c.941828.941827.941828 2.46883 8.87707e-07 3.41066 -3.83532e-07 3.83532e-07-7.68093e-07 7.68093e-07-1.15163e-06 1.15163e-06"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      ></path>
      <rect width="24" height="24" fill="none"></rect>
      <g transform="matrix(1 0 0 1 -4.97056 12)">
        <rect
          width="14.4075"
          height="4.82341"
          x="4.79623"
          y="9.5883"
          fill="none"
          rx="1.33193"
          ry="0"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          transform="matrix(.707107 -.707107 .707107 .707107 0 0)"
        ></rect>
      </g>
      <g transform="matrix(1 0 0 1 17.5 -7.24874)">
        <rect
          width="5.47279"
          height="6.7468"
          x="14.7636"
          y="14.1266"
          fill="none"
          rx="1.09369"
          ry="0"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          transform="matrix(.707107 .707107 -.707107 .707107 0 0)"
        ></rect>
      </g>
      <line
        x1="19.89"
        x2="15.11"
        y1="15.11"
        y2="19.89"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      ></line>
      <g transform="matrix(1 0 0 1 6.5 -2.69239)">
        <rect
          width="5.47279"
          height="6.7468"
          x="3.7636"
          y="3.1266"
          fill="none"
          rx="1.09369"
          ry="0"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          transform="matrix(.707107 .707107 -.707107 .707107 0 0)"
        ></rect>
      </g>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <line x1="8.89" x2="4.11" y1="4.11" y2="8.89"></line>
        <line x1="15.57" x2="13.71" y1="15.57" y2="13.71"></line>
        <line x1="10.29" x2="8.43" y1="10.29" y2="8.43"></line>
        <path d="M15.3885 3l-2.45286e-07 5.32907e-15c3.09914-1.35468e-07 5.61149 2.51235 5.61149 5.61149"></path>
        <path d="M8.61149 21l-2.45286e-07-7.10543e-15c-3.09914-1.35468e-07-5.61149-2.51235-5.61149-5.61149 0 0 0-1.77636e-15 0-1.77636e-15"></path>
      </g>
      <g transform="matrix(1 0 0 1 24 24)">
        <rect width="24" height="24" fill="none" transform="matrix(-1 1.22465e-16 -1.22465e-16 -1 0 0)"></rect>
      </g>
    </>
  ),
})

const SatelliteSignal: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    default:
      return <CustomIcon as={SatelliteSignalIconOutline} {...props} />
  }
}

export default memo(SatelliteSignal)
